import { company } from '~/company/Company';
import { ModalType } from '~/components/Modal/interface';

import { userStore } from '~/stores';

export const getAddressModalType = (): ModalType => {
  if (company.showNewAddressModal) {
    return userStore.addressList.length > 0
      ? ModalType.DeliveryAddressList
      : ModalType.EditAddressLocation;
  }
  return ModalType.DeliveryAddress;
};

export const getAddressModalParams = (
  source: string,
  params?: Record<string, string>,
): [ModalType, string, Record<string, string> | undefined] => {
  const extraParams = params && !company.showNewAddressModal;
  const targetModal = company.showNewAddressModal
    ? userStore.addressList.length > 0
      ? ModalType.DeliveryAddressList
      : ModalType.EditAddressLocation
    : ModalType.DeliveryAddress;

  return [targetModal, source, extraParams ? params : undefined];
};
